'use strict';

angular.module('ClinicApp').directive('appointmentStatusVerifyUpdate', function($q, AppointmentService, OCUtil, OCAppointmentUtil) {
  return {
    templateUrl: '/views/directives/_appointment-status-verify-update.html',
    scope: {
      appointment: '=appointmentStatusVerifyUpdate',
      onSuccess: '=',
      onResetTime: '=',
      futureTimeEnabled: '=',
      futureTimeError: '=',
      unscheduledOptionDisabled: '=',
    },
    link: function($scope) {
      $scope.userSelected = {};
      $scope.userSelected.verifyUpdateDate = {};
      $scope.userSelected.verifyUpdateDate.newDateTime = null;
      $scope.isCancelled = OCAppointmentUtil.isCancelled($scope.appointment.status);
      $scope.isRequested = OCAppointmentUtil.isRequested($scope.appointment.status);

      $scope.verifyUpdateDate = function(form) {
        if (form.$invalid) {
          return $q.reject();
        }
        var datetime = OCUtil.formatAppointmentTime($scope.userSelected.verifyUpdateDate.newDateTime);
        return AppointmentService.updateAppointment(
          $scope.appointment.id,
          datetime.date,
          datetime.startTime,
        ).then(function(appointment) {
          $scope.appointment = appointment;
          $scope.onSuccess();
        });
      };

      $scope.resetAppointmentTime = function() {
        return AppointmentService.resetAppointment($scope.appointment.id).then(function(appointment) {
          $scope.appointment = appointment;
          $scope.onResetTime('Requested');
        });
      };
    },
  };
});
